import axios, { type AxiosStatic } from 'axios';
export type { AxiosStatic };

export function getGlobalAxios() {
  return axios;
}
